<script lang="ts" setup>
import {
  IconChevronLeftLarge,
  IconChevronLeftSmall,
  IconChevronRightLarge,
  IconChevronRightSmall,
} from '@cypress-design/vue-icon'
import { computed } from 'vue'

const props = defineProps<{
  size: 'sm' | 'lg'
  purple?: boolean
}>()

const strokeColor = computed(() => {
  return props.purple ? 'purple-500' : 'gray-200'
})

const IconChevronLeft = computed(() => {
  return props.size === 'sm' ? IconChevronLeftSmall : IconChevronLeftLarge
})

const IconChevronRight = computed(() => {
  return props.size === 'sm' ? IconChevronRightSmall : IconChevronRightLarge
})
</script>

<template>
  <div
    class="flex"
    :class="{
      'gap-[6px]': size === 'sm',
      'gap-[16px]': size === 'lg',
    }"
  >
    <IconChevronLeft :stroke-color="strokeColor" />
    <IconChevronRight :stroke-color="strokeColor" />
  </div>
</template>
